module.exports = __webpack_public_path__ + "static/img/3.d3a199cb.jpg";